import findIndex from 'lodash/findIndex';

export default (state = {}, action = {}) => {
  switch(action.type) {
    case 'FETCH_FILES':
      if(action.payload.files.length>0){
        return {
          ...state,
          [action.payload.order_id]: action.payload.files
        }
      }
      else{
        return {
          ...state,
          [action.payload.order_id]: []
        }
      }
    case 'EDIT_FILE':
      const index = findIndex(state[action.payload.file_order_id],
        { file_id: action.payload.file_id });
      if (index >= 0) {
        return {
          ...state,
          [action.payload.file_order_id]:[
            ...state[action.payload.file_order_id].slice(0, index),
            action.payload,
            ...state[action.payload.file_order_id].slice(index + 1)
          ]
        }
      }
      return state;
    case 'CREATE_FILE':
      return {
        ...state,
        [action.payload.file_order_id]:[
          ...state[action.payload.file_order_id],
          action.payload
        ]
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/files.js